import {
  CustomerListResponse,
  CustomerListRequest,
  CustomAttributeFilterItem,
  CustomerSearchListRequest,
  CustomerPartyAccountResponse,
  CustomerPartyAccountRequest,
  CustomerPartyAccountBook,
  CreateCustomerReminderResponse,
  CreateCustomerReminderRequest,
  SendSMSToCustomersResponse,
  SendSMSToCustomersRequest,
  RemoveCustomerReminderResponse,
  RemoveCustomerReminderRequest,
  RemindersResponse,
  RemindersRequest,
  CustomerSMSTemplateResponse,
  CustomerSMSTemplateRequest,
  InvoicesTableListResponse,
  InvoicesTableListRequest,
  UpdateMobileNumberRequest,
  CustomerByIdResponse,
  CustomerByIdRequest,
  DownloadLedgerRequest,
  CustomerSearchResponse,
  CustomerSummaryResponse,
  CustomerSummaryRequest,
  InActiveCustomerResponse,
  InActiveCustomerRequest,
  CreateCustomerRequest,
  AssignTeamMemberOrCustomerRequest,
  DeleteTeamMemberOrCustomerRequest,
  AllCustomersAssignedResponse,
  AllCustomersAssignedParams,
  DownloadCustomerListResponse,
  DownloadCustomerListRequest,
  DownloadedCustomersHistoryResponse,
  DownloadedCustomersHistoryRequest,
  DownloadGeneratedCustomerListResponse,
  DownloadGeneratedCustomerListRequest,
  CreateCusomerBlukRequest,
  NewCreateCustomerResponse,
  CreateAttributeRequest,
  CreateAttributeResponse,
  FetchAllAttributesRequest,
  FetchAllAttributesResponse,
  FetchSingleAttributeRequest,
  FetchSingleAttributeResponse,
  DeleteAttributeRequest,
  DeleteAttributeResponse,
  customersByCode,
  OutstandingCustomersResponse,
  OutstandingCustomerRequest,
  CustomerFilters,
  DeleteCustomerContactsRequest,
  DeleteCustomerContactsResponse,
  findCustomerContactRequest,
  findCustomerContactResponse,
  createCustomerContactRequest,
  createCustomerContactResponse,
  ParseCustomerResponse,
} from './model';
import { Api } from '../api/root-api';
import _ from 'lodash';
import {
  addCustomerList,
  updatePatyAccountBook,
  updateInviteId,
  addRemindersData,
  updateInvoices,
  updateVisits,
  updateAllAssignedCustomers,
} from './slice';
import {
  addListInputItems,
  addTreeInputItems,
  setCustomerFilterAttributes,
} from '../filter/slice';
import { ListInputItemOptions, TreeInputItemOptions } from '../filter/model';
import { mapDataToInputItems } from '../filter/helpers';
import { traverseFilterTree } from './helpers';
import { getQueryParams } from '@zonofi/common';

export const customersApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerList: builder.query<CustomerListResponse, CustomerListRequest>({
      query(params: CustomerListRequest) {
        const {
          workspaceId,
          customAttributeFilter,
          includeFields,
          ...paramObject
        } = params;
        const param: any = {
          ...paramObject,
          sellerWorkspaceId: workspaceId,
        };
        const queryParams = getQueryParams(param);
        const parts: string[] = [queryParams];
        if (customAttributeFilter?.length) {
          parts.push(
            ...customAttributeFilter.map(
              (item: CustomAttributeFilterItem) =>
                `customAttributeFilter[]=${encodeURIComponent(JSON.stringify(item))}`
            )
          );
          if (params.includeAttributes !== false) {
            parts.push('includeAttributes=true');
          }
        }
        if (includeFields?.length) {
          parts.push(
            ...includeFields.map(
              (name) => `includeFields[]=${encodeURIComponent(name)}`
            )
          );
        }
        const fullQuery = parts.filter(Boolean).join('&');
        return {
          url: `hub/orgs/api/customers/${workspaceId}?${fullQuery}`,
          method: 'GET',
          headers: {
            'cache-control': 'no-cache',
          },
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(addCustomerList(data));
          if (request?.dispatchFilter) {
            const inputItems =
              data?.customers?.map((x) => {
                return {
                  id: x.id,
                  value: x.companyName,
                  selected: false,
                  eitherOr: request.eitherOr ? request.eitherOr : false,
                };
              }) || [];
            dispatch(
              addListInputItems({
                inputItems: inputItems,
                key: ListInputItemOptions.distributors,
              })
            );
          }
        } catch (err) {
          console.log(err, 'dispatchErr');
        }
      },
    }),
    getCustomerFilter: builder.query<
      CustomerFilters,
      { sellerWorkspaceId: string }
    >({
      query({ sellerWorkspaceId }) {
        return {
          url: `/hub/orgs/api/customers/filters?sellerWorkspaceId=${sellerWorkspaceId}`,
          method: 'GET',
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled
          .then((response) => {
            const { data } = response;
            const {
              customerSegment = [],
              divisions = [],
              routes = [],
              cfa = [],
              customerLifeCycleGroups = [],
              dynamicSegment = [],
              attributes = [],
            } = data || {};
            const divisionsInputItems = divisions.map(({ id, name }) => ({
              id,
              value: name,
              selected: false,
              eitherOr: false,
            }));
            dispatch(
              addListInputItems({
                inputItems: divisionsInputItems,
                key: ListInputItemOptions.divisions,
              })
            );
            const customerSegmentInput = traverseFilterTree(
              customerSegment,
              'Segments'
            );
            dispatch(
              addTreeInputItems({
                inputItems: customerSegmentInput,
                key: TreeInputItemOptions.threadSegments,
              })
            );
            const cfaInputItems = mapDataToInputItems(
              cfa,
              'id',
              'supplierName'
            );

            dispatch(
              addListInputItems({
                inputItems: cfaInputItems,
                key: ListInputItemOptions.cfa,
              })
            );

            const routesInput = traverseFilterTree(routes, 'Routes');
            dispatch(
              addTreeInputItems({
                inputItems: routesInput,
                key: TreeInputItemOptions.threadRoutes,
              })
            );
            const customerDynamcicSegmentsInput = traverseFilterTree(
              dynamicSegment,
              'Dynamic Segments'
            );
            dispatch(
              addTreeInputItems({
                inputItems: customerDynamcicSegmentsInput,
                key: TreeInputItemOptions.threadDynamicSegments,
              })
            );
            const customerLifeCycleGroupsInput = traverseFilterTree(
              customerLifeCycleGroups,
              'Customer Life Cycle'
            );
            dispatch(
              addTreeInputItems({
                inputItems: customerLifeCycleGroupsInput,
                key: TreeInputItemOptions.threadCustomerLifeCycleGroups,
              })
            );
            dispatch(setCustomerFilterAttributes(attributes));
          })

          .catch((error) => console.log('customer filter error', error));
      },
    }),

    getCustomerListSearch: builder.query<
      CustomerListResponse,
      CustomerSearchListRequest
    >({
      query(params: CustomerSearchListRequest) {
        const { workspaceId, ...paramObject } = params;
        const param = { ...paramObject, sellerWorkspaceId: workspaceId };
        const queryParams = getQueryParams(param);
        return {
          url: `hub/orgs/api/customers/${workspaceId}?${queryParams}`,
          method: 'GET',
          cache: 'no-cache',
        };
      },
    }),

    getCustomerPartyAccount: builder.query<
      CustomerPartyAccountResponse,
      CustomerPartyAccountRequest
    >({
      query(params: CustomerPartyAccountRequest) {
        return {
          url: `invoiceservice/partyAccountBook/balanceBySeller`,
          method: 'GET',
          params: params,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        try {
          const { inviteId } = request;
          dispatch(updateInviteId(inviteId));
          const { data } = await queryFulfilled;
          if (data) {
            const customer = _.first(data?.customers);
            const patyAccount: CustomerPartyAccountBook = {
              openingBalance: customer?.openingBalance,
              outStandingBalance: customer?.outStandingBalance,
              //@ts-ignore
              overdueAmount: customer?.overdueAmount,
              totalCredit: customer?.totalCredit,
              totalDebit: customer?.totalDebit,
              //@ts-ignore
              lastPayment: customer?.lastPayment,
              //@ts-ignore
              dueInvoice: customer?.dueInvoice,
            };
            dispatch(
              updatePatyAccountBook({
                partyAccountBook: patyAccount,
                id: inviteId,
              })
            );
          }
        } catch (err) {
          console.log(err, 'dispatchErr');
        }
      },
    }),
    createCustomerReminder: builder.mutation<
      CreateCustomerReminderResponse,
      CreateCustomerReminderRequest
    >({
      query(params: CreateCustomerReminderRequest) {
        return {
          url: `communication/reminder`,
          method: 'POST',
          body: params,
        };
      },
    }),
    sendSMSToCustomers: builder.mutation<
      SendSMSToCustomersResponse,
      SendSMSToCustomersRequest
    >({
      query(params: SendSMSToCustomersRequest) {
        return {
          url: `invoiceservice/communication/invites`,
          method: 'POST',
          body: params,
        };
      },
    }),
    removeCustomerReminder: builder.query<
      RemoveCustomerReminderResponse,
      RemoveCustomerReminderRequest
    >({
      query(params: RemoveCustomerReminderRequest) {
        const queryParams = getQueryParams(params);
        return {
          url: `communication/reminder/delete?${queryParams}`,
          method: 'GET',
        };
      },
    }),
    getReminders: builder.query<RemindersResponse, RemindersRequest>({
      query(params: RemindersRequest) {
        return {
          url: `communication/reminder`,
          method: 'GET',
          params: params,
        };
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          //@ts-ignore
          dispatch(addRemindersData(data?.reminderRecords));
        } catch (err) {
          dispatch(addRemindersData([]));
          console.log(err, 'dispatchErr');
        }
      },
    }),
    getCustomerSMSTemplate: builder.query<
      CustomerSMSTemplateResponse,
      CustomerSMSTemplateRequest
    >({
      query(params: CustomerSMSTemplateRequest) {
        return {
          url: `invoiceservice/communication/invites/template`,
          method: 'GET',
          params: params,
        };
      },
    }),
    getInvoicesTableList: builder.query<
      InvoicesTableListResponse,
      InvoicesTableListRequest
    >({
      query(params: InvoicesTableListRequest) {
        const { workspaceId, ...paramObject } = params;
        return {
          url: `invoiceservice/invoices/${workspaceId}`,
          method: 'GET',
          params: paramObject,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            updateInvoices({
              invoicesListResponse: data,
              id: request.inviteId,
            })
          );
        } catch (err) {
          console.log(err, 'dispatchErr');
        }
      },
    }),
    updateMobileNumber: builder.mutation<string, UpdateMobileNumberRequest>({
      query(params: UpdateMobileNumberRequest) {
        const { inviteId, ...bodyObject } = params;
        return {
          url: `customers/edit/${inviteId}`,
          method: 'PUT',
          body: bodyObject,
          responseHandler: (response) => response.text(),
        };
      },
    }),
    getCustomerById: builder.query<CustomerByIdResponse, CustomerByIdRequest>({
      query(params: CustomerByIdRequest) {
        console.log(params, 'customerDetails');
        const { workspaceId, ...paramObject } = params;
        return {
          url: `customers/${workspaceId}`,
          method: 'GET',
          params: paramObject,
        };
      },
    }),
    getCustomersByParams: builder.query<CustomerByIdResponse, customersByCode>({
      query(params: customersByCode) {
        const { workspaceId, customerCodeRes } = params;
        const searchParams = new URLSearchParams();
        customerCodeRes.forEach((code) => {
          searchParams.append('customerCodes', code);
        });

        return {
          url: `customers/${workspaceId}`,
          method: 'GET',
          params: searchParams,
        };
      },
    }),

    downloadLedger: builder.query<any, DownloadLedgerRequest>({
      query(params: DownloadLedgerRequest) {
        return {
          url: `invoiceservice/partyaccountbook/list/download`,
          method: 'GET',
          params: params,
          responseHandler: (response) => response.arrayBuffer(),
        };
      },
    }),
    getCheckinDetails: builder.query<any, { customerId: string }>({
      query(params) {
        return {
          url: `visit`,
          method: 'GET',
          params: params,
        };
      },
      async onQueryStarted(params, { dispatch, queryFulfilled }) {
        try {
          const { customerId } = params;
          const { data } = await queryFulfilled;
          dispatch(updateVisits({ visitResponse: data, id: customerId }));
        } catch (err) {
          console.log(err, 'dispatchErr');
        }
      },
    }),
    searchCustomer: builder.query<
      CustomerSearchResponse,
      {
        includeAttributes?: boolean;
        includeTeamMembers?: boolean;
        workspaceId: string;
        inviteId: string;
        includeInactive: boolean;
        includeCFA: boolean;
        isNoCache?: boolean;
        customerCode?: string;
      }
    >({
      query(arg) {
        return {
          url: `/hub/orgs/api/customer/details?sellerWorkspaceId=${arg.workspaceId}`,
          params: {
            inviteId: arg.inviteId,
            includeInactive: arg.includeInactive,
            includeCFA: arg.includeCFA,
            customerCode: arg?.customerCode,
            includeTeamMembers: arg?.includeTeamMembers,
            includeAttributes: arg.includeAttributes,
          },
          method: 'GET',
          ...(arg.isNoCache
            ? {
                headers: {
                  'Cache-control': 'no-cache',
                },
              }
            : {}),
        };
      },
    }),
    getCustomerSummary: builder.query<
      CustomerSummaryResponse[],
      CustomerSummaryRequest
    >({
      query(arg) {
        return {
          url: `hub/commerce-v2/customer/summary/${arg.principalWorkspaceId}-2?sellerWorkspaceId=${arg.principalWorkspaceId}`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    getuploadedFileData: builder.query<any, any>({
      query(arg) {
        return {
          url: `mdm-integration/uploadbatch/uploadedBatchFile`,
          method: 'GET',
          params: { ...arg, sendSSE: false },
        };
      },
    }),
    assignCustomerGroups: builder.mutation<
      any,
      { workspaceId: string; body: any }
    >({
      query(arg) {
        const { workspaceId, body } = arg;
        return {
          url: `teams/assign-customergroups/${workspaceId}`,
          method: 'POST',
          body: body,
        };
      },
    }),
    addGroupsToCustomers: builder.mutation<any, any>({
      query(arg) {
        const { senderWorkspaceId, body } = arg;
        return {
          url: `customers/groupassignment/${senderWorkspaceId}`,
          method: 'POST',
          body: body,
        };
      },
    }),
    inActiveCustomer: builder.mutation<
      InActiveCustomerResponse,
      InActiveCustomerRequest
    >({
      query(arg) {
        const { workspaceId, ...otherParams } = arg;
        return {
          url: `customer/${workspaceId}`,
          method: 'PATCH',
          params: otherParams,
        };
      },
    }),
    createCustomer: builder.mutation<
      any,
      {
        body: CreateCustomerRequest;
        workspaceId: string;
      }
    >({
      query(args) {
        return {
          url: `customers/create/${args.workspaceId}`,
          method: 'POST',
          body: args.body,
        };
      },
    }),
    updateCustomers: builder.mutation<
      any,
      {
        body: CreateCustomerRequest;
        workspaceId: string;
        inviteId: string;
      }
    >({
      query(args) {
        return {
          url: `customer/update/${args.inviteId}`,
          method: 'POST',
          body: args.body,
        };
      },
    }),
    orgsUpdateCustomers: builder.mutation<
      {
        message: string;
        statusCode: number;
      },
      {
        body: CreateCustomerRequest;
        workspaceId: string;
        inviteId: string;
      }
    >({
      query(args) {
        return {
          url: `hub/orgs/api/customer/update/${args.workspaceId}?sellerWorkspaceId=${args.workspaceId}`,
          method: 'POST',
          body: args.body,
        };
      },
    }),
    addCustomers: builder.mutation<any, any>({
      query(payload: CreateCusomerBlukRequest) {
        const { customers, sellerWorkspaceId } = payload;
        return {
          url: `hub/orgs/api/customers/create/bulk/${sellerWorkspaceId}?sellerWorkspaceId=${sellerWorkspaceId}`,
          method: 'POST',
          body: { customers },
        };
      },
    }),
    getTeamMemberCustomers: builder.query<any, any>({
      query(args) {
        return {
          url: `hub/orgs/api/team-member/customers`,
          params: args.params,
          method: 'GET',
        };
      },
    }),
    getAllAssignedCustomers: builder.query<
      AllCustomersAssignedResponse,
      AllCustomersAssignedParams
    >({
      query(arg) {
        const { dispatchFilter, ...restArgs } = arg;
        const queryParams = getQueryParams(restArgs);
        return {
          url: `team/customers?${queryParams}`,
          method: 'GET',
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        queryFulfilled
          .then((response) => {
            if (request?.dispatchFilter) {
              const cfaInputItems = mapDataToInputItems(
                response?.data?.filters?.cfas,
                'id',
                'supplierName'
              );
              dispatch(
                addListInputItems({
                  inputItems: cfaInputItems,
                  key: ListInputItemOptions.salesCfa,
                })
              );
              // update the assigned custoemrs list
              dispatch(updateAllAssignedCustomers(response?.data?.data || []));
            }
          })
          .catch((error) => console.log(error));
      },
    }),
    assignTeamMemberOrCustomer: builder.mutation<
      any,
      AssignTeamMemberOrCustomerRequest
    >({
      query(arg) {
        const { workspaceId, ...params } = arg;
        return {
          url: `hub/orgs/api/team-member/customer?sellerWorkspaceId=${arg.workspaceId}`,
          method: 'POST',
          body: params,
        };
      },
      // invalidatesTags: ['teamMemberList'],
    }),
    deleteTeamMemberOrCustomer: builder.mutation<
      any,
      DeleteTeamMemberOrCustomerRequest
    >({
      query(arg) {
        return {
          url: `team-member/customer/${arg.workspaceId}`,
          method: 'Delete',
          body: arg,
        };
      },
      // invalidatesTags: ['teamMemberList'],
    }),
    initiateCustomerListDownload: builder.mutation<
      DownloadCustomerListResponse,
      DownloadCustomerListRequest
    >({
      query: (args) => ({
        url: `hub/orgs/api/customers/catalogue/download/${args.workspaceId}`,
        method: 'GET',
        params: args.body,
      }),
    }),
    downloadedCustomersHistory: builder.query<
      DownloadedCustomersHistoryResponse[],
      DownloadedCustomersHistoryRequest
    >({
      query: (arg) => ({
        url: `downloadTasks/list-s3-contents/${arg?.workspaceId}?entity=customers&maxKeys=10`,
        method: 'GET',
      }),
    }),
    downloadGeneratedCustomerList: builder.query<
      DownloadGeneratedCustomerListResponse,
      DownloadGeneratedCustomerListRequest
    >({
      query: (arg) => ({
        url: `downloadTasks/download-s3-file/${arg?.workspaceId}?entity=customers&key=${arg?.key}`,
        method: 'GET',
      }),
    }),
    createNewCustomer: builder.mutation<
      NewCreateCustomerResponse,
      CreateCustomerRequest
    >({
      query: (body) => ({
        url: `hub/orgs/api/customers/create?sellerWorkspaceId=${body.senderWorkspaceId}`,
        method: 'POST',
        body,
      }),
    }),
    fetchAllAttributes: builder.query<
      FetchAllAttributesResponse,
      FetchAllAttributesRequest
    >({
      query: (args) => {
        return {
          url: '/hub/orgs/api/customer-attributes',
          method: 'GET',
          params: args.params,
        };
      },
    }),
    fetchSingleAttribute: builder.query<
      FetchSingleAttributeResponse,
      FetchSingleAttributeRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customer-attributes/${args.id}`,
          method: 'GET',
          params: args.params,
        };
      },
    }),
    createAttribute: builder.mutation<
      CreateAttributeResponse,
      CreateAttributeRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customer-attributes/`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    updateAttribute: builder.mutation<
      CreateAttributeResponse,
      CreateAttributeRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customer-attributes/${args.body.id ?? ''}`,
          method: 'PUT',
          body: args.body,
          params: args.params,
        };
      },
    }),
    deleteAttribute: builder.query<
      DeleteAttributeResponse,
      DeleteAttributeRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customer-attributes/${args.id}`,
          method: 'DELETE',
          params: args.params,
        };
      },
    }),
    deleteCustomerContact: builder.query<
      DeleteCustomerContactsResponse,
      DeleteCustomerContactsRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customers/contacts/${args.id}`,
          method: 'DELETE',
          params: args.params,
        };
      },
    }),
    findCustomerContact: builder.query<
      findCustomerContactResponse,
      findCustomerContactRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customers/contacts/find-by-phone`,
          method: 'GET',
          params: args.params,
        };
      },
    }),
    customerAsContact: builder.mutation<any, any>({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customers/contacts/convert`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    createCustomerContact: builder.mutation<
      createCustomerContactResponse,
      createCustomerContactRequest
    >({
      query: (args) => {
        return {
          url: `/hub/orgs/api/customers/contacts`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    getCustomerOutstanding: builder.mutation<
      OutstandingCustomersResponse,
      OutstandingCustomerRequest
    >({
      query: (args) => {
        return {
          url: `/hub/reports/api/v1/customer-metrics-report`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    parseCustomer: builder.mutation<
      ParseCustomerResponse,
      {
        formData: FormData;
        sellerWorkspaceId: string;
      }
    >({
      query: (args) => ({
        url: `/hub/bot/api/v1/parse/customer?sellerWorkspaceId=${args.sellerWorkspaceId}`,
        method: 'POST',
        body: args.formData,
      }),
    }),
  }),
});

export const {
  useGetCustomerListQuery,
  useLazyGetCustomerListQuery,
  useGetCustomerListSearchQuery,
  useLazyGetCustomerListSearchQuery,
  useGetCustomerPartyAccountQuery,
  useLazyGetCustomerPartyAccountQuery,
  useCreateCustomerReminderMutation,
  useSendSMSToCustomersMutation,
  useLazyRemoveCustomerReminderQuery,
  useGetRemindersQuery,
  useLazyGetRemindersQuery,
  useGetCustomerSMSTemplateQuery,
  useLazyGetCustomerSMSTemplateQuery,
  useGetInvoicesTableListQuery,
  useLazyGetInvoicesTableListQuery,
  useUpdateMobileNumberMutation,
  useGetCustomerByIdQuery,
  useLazyGetCustomersByParamsQuery,
  useLazyGetCustomerByIdQuery,
  useDownloadLedgerQuery,
  useLazyDownloadLedgerQuery,
  useGetCheckinDetailsQuery,
  useLazyGetCheckinDetailsQuery,
  useLazySearchCustomerQuery,
  useLazyGetCustomerSummaryQuery,
  useLazyGetuploadedFileDataQuery,
  useAddGroupsToCustomersMutation,
  useInActiveCustomerMutation,
  useAssignCustomerGroupsMutation,
  useCreateCustomerMutation,
  useUpdateCustomersMutation,
  useOrgsUpdateCustomersMutation,
  useLazyGetAllAssignedCustomersQuery,
  useAssignTeamMemberOrCustomerMutation,
  useDeleteTeamMemberOrCustomerMutation,
  useInitiateCustomerListDownloadMutation,
  useLazyDownloadedCustomersHistoryQuery,
  useLazyDownloadGeneratedCustomerListQuery,
  useLazyGetTeamMemberCustomersQuery,
  useAddCustomersMutation,
  useLazyGetCustomerFilterQuery,
  useCreateNewCustomerMutation,
  useCreateAttributeMutation,
  useUpdateAttributeMutation,
  useLazyDeleteAttributeQuery,
  useLazyDeleteCustomerContactQuery,
  useLazyFetchAllAttributesQuery,
  useLazyFetchSingleAttributeQuery,
  useGetCustomerOutstandingMutation,
  useLazyFindCustomerContactQuery,
  useCreateCustomerContactMutation,
  useCustomerAsContactMutation,
  useParseCustomerMutation,
} = customersApi;
